import {
  removeKeyFromObjectAction,
  removeItemFromArrayAction
} from "services/mutator/actions"

import { iterateAction } from "services/mutator/mutator.service"

export const null_ruleset = {}

export const BT_retention_ruleset = {
  extras: [
    {
      action: removeKeyFromObjectAction,
      attr: null,
      keyToDelete: "COMPLETE_WIFI",
      condition: (dataObj, { efsdata: { haveCompleteWifi } }) =>
        haveCompleteWifi === 1
    }
  ],
  plans: [
    {
      action: removeKeyFromObjectAction,
      attr: "PLAN_1.devices.BT_ROUTER",
      keyToDelete: "ooc",
      condition: (dataObj, { efsdata: { haveHalo } }) => haveHalo === 1
    },
    {
      action: removeKeyFromObjectAction,
      attr: "PLAN_3.devices.BT_ROUTER",
      keyToDelete: "ooc",
      condition: (dataObj, { efsdata: { haveHalo } }) => haveHalo === 1
    },
    {
      action: removeKeyFromObjectAction,
      attr: "PLAN_4.devices.BT_ROUTER",
      keyToDelete: "ooc",
      condition: (dataObj, { efsdata: { haveHalo } }) => haveHalo === 1
    },
    {
      action: removeKeyFromObjectAction,
      attr: "PLAN_5_A.devices.BT_ROUTER",
      keyToDelete: "ooc",
      condition: (dataObj, { efsdata: { haveHalo } }) => haveHalo === 1
    },
    {
      action: removeItemFromArrayAction,
      attr: "PLAN_1.benefits",
      filter: benefit =>
        benefit !== "BT_MANAGE_SCREEN_TIME" &&
        benefit !== "BT_KEEP_CONNECTED" &&
        benefit !== "BT_DOUBLE_DATA_2" &&
        benefit !== "BT_PRICE_PROMISE",
      condition: (dataObj, { efsdata: { haveHalo } }) =>
        haveHalo !== 1 &&
        dataObj.PLAN_1 &&
        dataObj.PLAN_1.data.name !== "Fibre 100" &&
        !/Full Fibre/.test(dataObj.PLAN_1.data.name)
    },
    {
      action: removeItemFromArrayAction,
      attr: "PLAN_2.benefits",
      filter: benefit =>
        benefit !== "BT_ALWAYS_ON" && benefit !== "BT_COMPLETE_WIFI",
      condition: (dataObj, { efsdata: { haveHalo } }) => haveHalo !== 1
    },
    {
      action: removeItemFromArrayAction,
      attr: "PLAN_3.benefits",
      filter: benefit =>
        benefit !== "BT_MANAGE_SCREEN_TIME" &&
        benefit !== "BT_KEEP_CONNECTED" &&
        benefit !== "BT_DOUBLE_DATA_2" &&
        benefit !== "BT_PRICE_PROMISE",
      condition: (dataObj, { efsdata: { haveHalo } }) =>
        haveHalo !== 1 &&
        dataObj.PLAN_3 &&
        dataObj.PLAN_3.data.name !== "Fibre 100" &&
        !/Full Fibre/.test(dataObj.PLAN_3.data.name)
    },
    {
      action: removeItemFromArrayAction,
      attr: "PLAN_4.benefits",
      filter: benefit =>
        benefit !== "BT_MANAGE_SCREEN_TIME" &&
        benefit !== "BT_KEEP_CONNECTED" &&
        benefit !== "BT_DOUBLE_DATA_2" &&
        benefit !== "BT_PRICE_PROMISE",
      condition: (dataObj, { efsdata: { haveHalo } }) =>
        haveHalo !== 1 &&
        dataObj.PLAN_4 &&
        dataObj.PLAN_4.data.name !== "Fibre 100" &&
        !/Full Fibre/.test(dataObj.PLAN_4.data.name)
    },
    {
      action: removeItemFromArrayAction,
      attr: "PLAN_5_A.benefits",
      filter: benefit =>
        benefit !== "BT_MANAGE_SCREEN_TIME" &&
        benefit !== "BT_KEEP_CONNECTED" &&
        benefit !== "BT_DOUBLE_DATA_2" &&
        benefit !== "BT_PRICE_PROMISE",
      condition: (dataObj, { efsdata: { haveHalo } }) => haveHalo !== 1
    },
    {
      action: removeItemFromArrayAction,
      attr: "PLAN_6.benefits",
      filter: benefit =>
        benefit !== "BT_ALWAYS_ON" && benefit !== "BT_COMPLETE_WIFI",
      condition: (dataObj, { efsdata: { haveHalo } }) => haveHalo !== 1
    },
    {
      action: removeItemFromArrayAction,
      attr: "PLAN_7.benefits",
      filter: benefit =>
        benefit !== "BT_ALWAYS_ON" && benefit !== "BT_COMPLETE_WIFI",
      condition: (dataObj, { efsdata: { haveHalo } }) => haveHalo !== 1
    },
    {
      action: removeKeyFromObjectAction,
      attr: null,
      keyToDelete: "PLAN_2",
      condition: (dataObj, { efsdata: { haveHalo } }) =>
        dataObj.PLAN_1 &&
        (dataObj.PLAN_1.data.name === "Fibre 100" ||
          /Full Fibre/.test(dataObj.PLAN_1.data.name)) &&
        haveHalo !== 1
    },
    {
      action: removeKeyFromObjectAction,
      attr: null,
      keyToDelete: "PLAN_6",
      condition: (dataObj, { efsdata: { haveHalo } }) =>
        dataObj.PLAN_3 &&
        (dataObj.PLAN_3.data.name === "Fibre 100" ||
          /Full Fibre/.test(dataObj.PLAN_3.data.name)) &&
        haveHalo !== 1
    },
    {
      action: removeKeyFromObjectAction,
      attr: null,
      keyToDelete: "PLAN_7",
      condition: (dataObj, { efsdata: { haveHalo } }) =>
        dataObj.PLAN_4 &&
        (dataObj.PLAN_4.data.name === "Fibre 100" ||
          /Full Fibre/.test(dataObj.PLAN_4.data.name)) &&
        haveHalo !== 1
    },
    {
      action: iterateAction,
      // exceptKeys: ["PLAN_1"],
      operator: {
        action: removeKeyFromObjectAction,
        attr: "data",
        keyToDelete: "postName",
        condition: (dataObj, { efsdata: { haveHalo } }) =>
          haveHalo !== 1 &&
          (dataObj.data.name === "Fibre 100" ||
            /Full Fibre/.test(dataObj.data.name)) &&
          dataObj.data.postName === " {currentHalo}"
      }
    }
  ]
}
